// @ts-strict

import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-additional-link-parameters',
  templateUrl: './additional-link-parameters.component.html',
  styleUrls: ['./additional-link-parameters.component.scss']
})
export class AdditionalLinkParametersComponent {
  @Output() emitSubs: EventEmitter<Array<string>> = new EventEmitter();

  public isAdditionalParameters = false;

  private subsToAddToURL: string[] = [];

  public toggleAdditionalParams(): void {
    this.isAdditionalParameters = !this.isAdditionalParameters;
    if (!this.isAdditionalParameters) {
      this.subsToAddToURL = [];
      this.emitSubs.emit(this.subsToAddToURL);
    }
  }

  public getText(event: Event, index: number): void {
    const target = event.target as HTMLInputElement;

    if (target.value !== '') {
      this.subsToAddToURL[index] = `ml_sub${index + 1}=${target.value.trim()}`;
    } else {
      this.subsToAddToURL.splice(index, 1);
    }
    this.emitSubs.emit(this.subsToAddToURL);
  }
}
